// THUẦN, đọc-thuần (ticket #138 phase-02, B7 — chuyển từ phase-03 sang đây để
// vế "check" của doctor xanh được ngay ở phase-02, tránh định nghĩa 2 lần).
// Tên các repo còn block Avatar SÓT LẠI trong .gitignore (sau khi đích ghi đã
// chuyển sang info/exclude). Không backup, không ghi, không tạo thư mục — dùng
// bởi doctor check (vế check) và phase-03 self-heal strip (import, không định
// nghĩa lại).
import { readFile } from "node:fs/promises";
import { join } from "node:path";
import { pathExists } from "./filesystem-helpers.js";
import { AVATAR_MARKER_START } from "./gitignore-template-loader.js";
import { readReposManifest } from "./workspace-repos-manifest-store.js";

export async function findReposWithBlockInGitignore(workspaceRoot: string): Promise<string[]> {
  const repos = await readReposManifest(workspaceRoot);
  const found: string[] = [];
  for (const r of repos) {
    const repoPath = join(workspaceRoot, r.path);
    const gitignorePath = join(repoPath, ".gitignore");
    if (!(await pathExists(gitignorePath))) continue;
    const content = await readFile(gitignorePath, "utf8");
    if (content.includes(AVATAR_MARKER_START)) found.push(r.name);
  }
  return found;
}
